module.exports = __webpack_public_path__ + "img/el_info-circle.b09e50b4.svg";